<script lang="ts" generics="T extends string | number">
  let {
    label,
    value = $bindable(),
    options,
    testid,
  }: { label?: string; value: T; options: { value: T; label: string }[]; testid?: string } = $props();
</script>

<label class="field">
  {#if label}<span>{label}</span>{/if}
  <select bind:value data-testid={testid}>
    {#each options as o (o.value)}
      <option value={o.value}>{o.label}</option>
    {/each}
  </select>
</label>

<style>
  .field {
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 13px;
  }
</style>
